<template>
<div class="chapter">
<div class="inner_page">
<div class="image_containert"><img alt="images" src="images/f00ii-01.jpg"/>
<p class="caption">996 Turbo with ‘starfish’ alloys. Powering away.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Front.vue?744206fc